import { PaperclipIcon } from "../icons/paper-clip";

interface UploadImageInputProps {
  onUpload: (files: File[]) => void;
  button?: React.ReactNode;
  accept?: string;
}

export function UploadImageInput({
  onUpload,
  button,
  accept,
}: UploadImageInputProps) {
  const handleUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files) onUpload(Array.from(event.target.files));
  };

  const handleButtonClick = () => {
    const input = document.querySelector(
      'input[type="file"]'
    ) as HTMLInputElement;
    input?.click();
  };

  return (
    <div className="relative">
      <div
        className="cursor-pointer p-2 ml-1 flex items-center self-center rounded-full hover:bg-cream-100 transition-all"
        onClick={handleButtonClick}
      >
        {button || (
          <PaperclipIcon className="w-5 h-5 text-terracotta-500 transition-colors" />
        )}
      </div>
      <input
        data-testid="upload-image-input"
        type="file"
        accept={accept}
        multiple
        hidden
        onChange={handleUpload}
      />
    </div>
  );
}
